
import { Link } from "react-router-dom";
import AkkhorLayout from "../../layout/AkkhorLayout";
import List from "../../component/List";


export default function DanhSachTaiKhoan() {
    let params = '';
    const columns = [
        { name: "id", label: "ID", options: { filter: false, sort: true } },
        { name: "fullname", label: "Họ tên", options: { filter: true, sort: true } },
        { name: "email", label: "Email", options: { filter: true, sort: true } },
        { name: "code", label: "MSNV", options: { filter: true, sort: true } },
        {
            name: "type", label: "Loại tài khoản",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if (value == 1) {
                        return "HO"
                    }
                    if (value == 2) {
                        return "Sale"
                    }
                },
            }
        },
        { name: "datecreate", label: "Ngày tạo", }
    ];

    return (<AkkhorLayout idrole="users">
        <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Danh sách tài khoản
                </li>
            </ul>
        </div>
        <List name="users" idrole="users" params={params} title="" defaultLimit={50} serverSide={true} columns={columns}></List>
    </AkkhorLayout>);
}
